export default {
  PrefixName: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
